import { render, staticRenderFns } from "./DocumentNotAvailable.vue?vue&type=template&id=594d93d2&scoped=true"
import script from "./DocumentNotAvailable.vue?vue&type=script&lang=js"
export * from "./DocumentNotAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d93d2",
  null
  
)

export default component.exports